import ProChip from "../ProChip";

const InfiniteModeProInfo = () => {
  return (
    <div>
      <ProChip /> Feature - If the alert has the infinite mode on, the alert won't be turned off
      when there's an update. PRO users will keep getting updates all the time. Never miss a deal!
    </div>
  );
};
export default InfiniteModeProInfo;
